<div class="comment single-comment-gallery">
  <div
    [title]="getTitle(comment)"
    [ngClass]="{
      'task-mark': true,
      redTask: isRed(comment),
      greenTask: isGreen(comment),
      yellowTask: isYellow(comment)
    }"
    *ngIf="comment.task && comment.task.taskId"
  >
    Задача для МЧ
    <span
      [ngClass]="{
        'task-light': true,
        redLight: isRed(comment),
        greenLight: isGreen(comment),
        yellowLight: isYellow(comment)
      }"
    ></span>
  </div>
  <div class="comment__info info info_custom">
    <div class="coment-autor">
      <div class="info__avater">
        <ng-container *ngIf="comment.user?.photoUrl; else noAva">
          <img class="border-radius-50" src="{{ comment.user.photoUrl }}" />
        </ng-container>
        <ng-template #noAva>
          <app-icon
            class="default-avatar"
            [icon]="['fas', 'user-circle']"
            [class]="'profile-dropdown-avatar-icon'"
            [color]="'#ffffff'"
            [iconName]="['Peoples', 'user']"
            [size]="'40px'"
          ></app-icon>
        </ng-template>
      </div>
      <div>
        <div class="info__username">
          {{ comment.user?.fullName || comment.user?.login }}
        </div>
        <div class="info__date">
          {{ comment.commentCreatedDate | date : "dd.MM.yyyy г. в HH:mm" }}
        </div>
      </div>
    </div>
  </div>

  <div class="comment__text comment__text_custom">
    <span> {{ comment.comment }}</span>
  </div>

  <div class="task-result-photo">
    <ng-container *ngIf="comment.task.photo.length">
      <div *ngFor="let photo of comment.task.photo" class="photo-item">
        <img
          (click)="onCompareClick({ url: photo, from: 'comment' })"
          [src]="photo"
          alt=""
        />
      </div>
    </ng-container>
    <ng-template #noPhoto>
      <div class="no-photo">
        <img src="/assets/images/no_photo.jpg" alt="" />
      </div>
    </ng-template>
  </div>

  <div class="info__date_custom">
    <div *ngIf="comment.task && comment.task.taskId">
      <ng-container *ngIf="!isTaskOpen">
        <div (click)="openTask()" class="show-info-button">
          Показать ответ по задаче
          <fa-icon [icon]="['fas', 'chevron-down']"></fa-icon>
        </div>
      </ng-container>
      <ng-container *ngIf="isTaskOpen">
        <div (click)="closeTask()" class="show-info-button">
          Скрыть ответ по задаче<fa-icon
            [icon]="['fas', 'chevron-up']"
          ></fa-icon>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="isTaskOpen" class="task-result">
    <!-- <ng-container *ngIf="task$|async else loadingTask"> -->
    <ng-container *ngIf="comment.result.length !== 0; else noResult">
      <ng-container *ngFor="let task of comment.result">
        <div class="comment__info info info_custom">
          <div class="coment-autor">
            <div class="info__avater">
              <ng-container *ngIf="task.photoUrl; else noAva">
                <img
                  class="avatar-img border-radius-50"
                  src="{{ task.photoUrl }}"
                />
              </ng-container>
              <ng-template #noAva>
                <!-- <fa-icon
                  class="default-avatar task task-icon"
                  [icon]="['fas', 'user-circle']"
                ></fa-icon> -->
                <app-icon
                  class="default-avatar task task-icon"
                  [icon]="['fas', 'user-circle']"
                  [class]="'profile-dropdown-avatar-icon'"
                  [color]="'#ffffff'"
                  [iconName]="['Peoples', 'user']"
                  [size]="'40px'"
                ></app-icon>
              </ng-template>
            </div>
            <div>
              <div class="info__username">
                {{ task.fullName || task.login }}
              </div>
              <div class="info__date">
                {{ task.commentCreatedDate | date : "dd.MM.yyyy г. в HH:mm" }}
              </div>
            </div>
          </div>
        </div>

        <div class="task-result-text">
          {{ task.message ? task.message : "Комментарий не предусмотрен" }}
        </div>

        <div class="task-result-photo__task">
          <ng-container *ngIf="task.photo.length">
            <div *ngFor="let photo of task.photo" class="photo-item">
              <img
                (click)="onCompareClick({ url: photo, from: 'task' })"
                [src]="photo"
                alt=""
              />
            </div>
          </ng-container>
          <ng-template #noPhoto>
            <div class="no-photo">
              <img src="/assets/images/no_photo.jpg" alt="" />
            </div>
          </ng-template>
        </div>

        <div class="info__date info__date_custom">
          <!-- <div *ngIf="comment.taskId">
         <ng-container *ngIf="!isTaskOpen">
            <div (click)="openTask()" class="show-info-button">Показать ответ по задаче</div>
         </ng-container>
                <ng-container *ngIf="isTaskOpen">
          <div  (click)="closeTask()"class="show-info-button"> Скрыть ответ по задаче</div>
         </ng-container>
      </div> -->
        </div>
      </ng-container>
    </ng-container>
    <ng-template #noResult>
      <div *ngIf="comment.status == 'success'" class="task-result-text__noTask">
        Скоро здесь будут отображаться результаты выполнения задачи
      </div>
      <div
        *ngIf="comment.status == 'in_progress'"
        class="task-result-text__noTask"
      >
        Скоро здесь будут отображаться результаты выполнения задачи
      </div>
      <div
        *ngIf="comment.status == 'failed'"
        class="task-result-text__noTask task-result-text__noTask__error"
      >
        <div class="text-failed">Задача не была выполнена</div>
        <div *ngIf="comment.user.login == user.login" class="button-container">
          <button (click)="longTask(comment)">Продлить</button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
